import styled from "@emotion/styled"

const Text = styled.span(
  {
    fontFamily: "Avenir Next",
  },
  props => ({
    fontSize: props.fontSize ? props.fontSize : "15px",
    color: props.color,
    fontWeight: props.bold ? "bold" : "none",
    textAlign: props.textAlign,
    textDecoration: props.textDecoration,
    display: props.inlineBox ? "contents" : "block",
    visibility: props.hidden ? "hidden" : "visible",
  })
)

export default Text
